(() => {
  const selector = '[id^="newsletterModal_"]';
  const styleId = 'prison-welcome-popup-styles';
  let activeModal = null;
  let previousFocus = null;
  let frame = 0;
  const css = `
html:has([data-prison-welcome-modal]) { overflow: hidden; }
body [data-prison-welcome-modal] {
  position: fixed !important; inset: 0 !important; width: 100% !important; height: 100% !important;
  box-sizing: border-box !important; background: rgba(0, 0, 0, .38) !important; z-index: 10000 !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-panel] {
  position: absolute !important; top: 96px !important; left: 24px !important; right: auto !important; bottom: auto !important;
  width: 400px !important; max-width: calc(100vw - 48px) !important;
  height: min(580px, calc(100dvh - 120px)) !important; max-height: none !important;
  display: grid !important; grid-template-rows: minmax(0, 1fr) 180px !important;
  box-sizing: border-box !important; padding: 0 !important; margin: 0 !important;
  background: #fff !important; background-image: none !important; border: 0 !important;
  border-radius: 0 !important; overflow: hidden !important; box-shadow: 0 8px 32px #0002 !important;
  animation: prison-welcome-left .32s ease-out both !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-content] {
  grid-row: 1 !important; display: flex !important; flex-direction: column !important; align-items: stretch !important;
  justify-content: flex-start !important; row-gap: 16px !important; width: 100% !important;
  min-width: 0 !important; min-height: 0 !important; padding: 26px !important; margin: 0 !important;
  background: #fff !important; background-image: none !important; box-sizing: border-box !important;
  overflow-x: hidden !important; overflow-y: auto !important; overscroll-behavior: contain; scrollbar-width: thin;
}
body [data-prison-welcome-modal] [data-prison-welcome-photo] {
  grid-row: 2 !important; width: 100% !important; height: 100% !important; min-height: 0 !important;
  overflow: hidden !important; background: #e8e5e2 !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-photo] img {
  display: block !important; width: 100% !important; height: 100% !important; max-width: none !important;
  object-fit: cover !important; object-position: center 18% !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-content] h2,
body [data-prison-welcome-modal] [data-prison-welcome-content] p {
  font-family: Arial, 'Helvetica Neue', sans-serif !important; font-weight: 400 !important;
  letter-spacing: 0 !important; text-transform: none !important; color: #111 !important; margin: 0 !important; max-width: none !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-content] h2 {
  font-size: 19px !important; line-height: 1.28 !important; padding-right: 28px !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-content] p { font-size: 14px !important; line-height: 1.45 !important; }
body [data-prison-welcome-modal] [data-prison-welcome-content] .form-group {
  width: 100% !important; margin: 0 !important; padding: 0 !important; box-sizing: border-box !important; flex-shrink: 0 !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-content] .outlined-input {
  width: 100% !important; height: 44px !important; min-height: 44px !important; box-sizing: border-box !important;
  padding: 10px 14px !important; border: 1px solid #ddd !important; border-radius: 0 !important;
  background: #f5f5f5 !important; color: #111 !important; font: 14px Arial, 'Helvetica Neue', sans-serif !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-content] .outlined-label {
  font: 13px Arial, 'Helvetica Neue', sans-serif !important; color: #555 !important; background: #f5f5f5 !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-content] .form-group.error .outlined-input { border-color: #b3261e !important; }
body [data-prison-welcome-modal] [data-prison-welcome-content] .form-group.error .outlined-label { color: #b3261e !important; }
body [data-prison-welcome-modal] [data-prison-welcome-content] .btn-send,
body [data-prison-welcome-modal] [data-prison-welcome-content] .btn-go {
  flex-shrink: 0 !important; width: 100% !important; min-width: 0 !important; min-height: 44px !important;
  box-sizing: border-box !important; padding: 12px 16px !important; margin: 0 !important; border: 0 !important;
  border-radius: 0 !important; background: #111 !important; color: #fff !important;
  font: 14px Arial, 'Helvetica Neue', sans-serif !important; font-weight: 400 !important; box-shadow: none !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-close] {
  position: absolute !important; top: 4px !important; right: 4px !important; left: auto !important; bottom: auto !important;
  z-index: 2 !important; width: 44px !important; height: 44px !important; padding: 10px !important; margin: 0 !important;
  display: grid !important; place-items: center !important; box-sizing: border-box !important;
  border: 0 !important; background: transparent !important; color: #111 !important; cursor: pointer !important;
}
body [data-prison-welcome-modal] [data-prison-welcome-close]:focus-visible,
body [data-prison-welcome-modal] [data-prison-welcome-content] :focus-visible { outline: 2px solid #111 !important; outline-offset: -2px !important; }
@keyframes prison-welcome-left { from { transform: translateX(calc(-100% - 24px)); } to { transform: translateX(0); } }
@keyframes prison-welcome-up { from { transform: translateY(100%); } to { transform: translateY(0); } }
@media (max-width: 768px) {
  body [data-prison-welcome-modal] [data-prison-welcome-panel] {
    top: auto !important; left: 0 !important; right: 0 !important; bottom: 0 !important;
    width: 100% !important; max-width: 100% !important; height: min(580px, 80vh) !important; height: min(580px, 80dvh) !important;
    grid-template-rows: minmax(0, 1fr) clamp(88px, 12dvh, 112px) !important; border-radius: 12px 12px 0 0 !important;
    animation: prison-welcome-up .32s ease-out both !important;
  }
  body [data-prison-welcome-modal] [data-prison-welcome-content] { padding: 16px 20px !important; row-gap: 10px !important; }
  body [data-prison-welcome-modal] [data-prison-welcome-content] h2 { font-size: 16px !important; line-height: 1.25 !important; padding-right: 28px !important; }
  body [data-prison-welcome-modal] [data-prison-welcome-content] .outlined-input { height: 40px !important; min-height: 40px !important; }
  body [data-prison-welcome-modal] [data-prison-welcome-content] .btn-send,
  body [data-prison-welcome-modal] [data-prison-welcome-content] .btn-go { min-height: 40px !important; padding: 10px 16px !important; }
  body [data-prison-welcome-modal] [data-prison-welcome-photo] { padding-bottom: env(safe-area-inset-bottom, 0px) !important; box-sizing: border-box !important; }
}
@media (prefers-reduced-motion: reduce) { body [data-prison-welcome-modal] [data-prison-welcome-panel] { animation: none !important; } }
`;

  function adapt(modal) {
    if (modal.hasAttribute('data-prison-welcome-modal')) return;
    const title = modal.querySelector('h2');
    const offer = title?.textContent?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    if (!offer || !/10\s*(?:off|%)/i.test(offer) || !offer.includes('compra')) return;
    const panel = modal.querySelector('[class^="modal-container-"]');
    const content = panel?.querySelector('[class^="form-container-"]');
    const close = panel?.querySelector('[class^="btn-close-"]');
    if (!panel || !content || !close) return;
    const background = panel.style.backgroundImage || getComputedStyle(panel).backgroundImage;
    const imageUrl = background.match(/^url\(["']?(.*?)["']?\)$/)?.[1];
    if (!imageUrl) return;
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      document.head.appendChild(style);
    }
    modal.setAttribute('data-prison-welcome-modal', '');
    panel.setAttribute('data-prison-welcome-panel', '');
    content.setAttribute('data-prison-welcome-content', '');
    close.setAttribute('data-prison-welcome-close', '');
    for (const image of panel.querySelectorAll('[class^="image-container-"], .mobile-image-container')) image.hidden = true;
    const photo = document.createElement('div');
    photo.setAttribute('data-prison-welcome-photo', '');
    const image = document.createElement('img');
    image.src = imageUrl;
    image.alt = '';
    image.decoding = 'async';
    photo.appendChild(image);
    panel.appendChild(photo);
    close.setAttribute('role', 'button');
    close.setAttribute('tabindex', '0');
    close.setAttribute('aria-label', 'Fechar popup');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    title.id ||= `prison-welcome-title-${modal.id}`;
    modal.setAttribute('aria-labelledby', title.id);
    previousFocus = document.activeElement;
    activeModal = modal;
    close.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); close.click(); }
    });
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close.click(); }
      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll('input:not([disabled]), button:not([disabled]), [tabindex="0"]')]
        .filter(element => element.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    if (document.querySelector('[data-prison-native-popup-preview]')) {
      const submit = content.querySelector('.btn-send');
      if (submit) submit.disabled = true;
    }
    close.focus({ preventScroll: true });
  }

  function scan() {
    frame = 0;
    document.querySelectorAll(selector).forEach(adapt);
    if (activeModal && !activeModal.isConnected) {
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      activeModal = null;
      previousFocus = null;
    }
  }

  function start() {
    if (document.querySelector('[data-prison-native-popup-preview]')) {
      const dismissalKey = '_mn_929cfb79-511e-4575-bc64-cec44052d519';
      document.cookie = `${dismissalKey}=; Max-Age=0; path=/; SameSite=Lax; Secure`;
      for (const storage of ['localStorage', 'sessionStorage']) {
        try { window[storage].removeItem(dismissalKey); } catch {}
      }
    }
    scan();
    new MutationObserver(() => { if (!frame) frame = requestAnimationFrame(scan); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

